module.exports = __webpack_public_path__ + "right-arrow-2a2a6d7bb66bc5826362.svg";